// account data related unstable prefixes
// don't import this file directly, import '$unstable/prefixes'
// partly migrated from src/types/matrix/accountData.ts

/**
 * @deprecated no longer part of MSC
 */
export const MATRIX_UNSTABLE_ACCOUNT_USER_EMOTES_PROPERTY_NAME = 'im.ponies.user_emotes';

export const MATRIX_ACCOUNT_EMOTE_ROOMS_PROPERTY_NAME = 'm.image_pack.rooms';
export const MATRIX_UNSTABLE_ACCOUNT_EMOTE_ROOMS_PROPERTY_NAME = 'im.ponies.emote_rooms';
